import "./social-module.scss";